"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _baggageHeader = _interopRequireDefault(require("../BaggageHeader/baggageHeader.proptypes"));
var _default = {
  PropTypes: {
    theme: _propTypes.string.isRequired,
    accessible: _propTypes.bool,
    isMobile: _propTypes.bool,
    baggageData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      baggageType: _propTypes.string.isRequired,
      baggageTypeColor: _propTypes.string.isRequired,
      baggageHeadingColor: _propTypes.string.isRequired,
      showToolTip: _propTypes.bool.isRequired,
      toolTipColor: _propTypes.string.isRequired,
      baggageList: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
        title: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
          weight: _propTypes.string,
          dimension: _propTypes.string
        })),
        currency: _propTypes.string,
        amount: _propTypes.number,
        id: _propTypes.string,
        isPreSelected: _propTypes.bool,
        originalPrice: _propTypes.object,
        availability: (0, _propTypes.shape)({
          checkRequired: _propTypes.bool,
          count: _propTypes.number
        }),
        isUnAvailable: _propTypes.bool
      })).isRequired,
      customToolTipContent: _propTypes.element,
      toolTipTitle: _propTypes.string.isRequired,
      toolTipContent: _baggageHeader.default.PropTypes.toolTipContent
    })).isRequired,
    selectedBaggage: _propTypes.object.isRequired,
    onBaggageSelection: _propTypes.func.isRequired,
    type: _propTypes.string,
    showUpsellBanner: _propTypes.bool,
    upsellBannerConfig: _propTypes.object,
    setNoneAsDefault: _propTypes.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: false,
    isMobile: false,
    baggageData: [],
    selectedBaggage: {},
    onBaggageSelection: function onBaggageSelection() {},
    type: '',
    toolTipTitle: '',
    toolTipContent: [],
    setNoneAsDefault: false
  }
};
exports.default = _default;